import React, { Component } from 'react';
import './App.css';
import Login from './login.js';
import TwoFactor from './twoFactor.js';
import { instanceOf } from 'prop-types';
import { withCookies, Cookies } from 'react-cookie';

var Views = {}
var comps = require.context('./Views', false, /.*/)
comps.keys().forEach((item) => {
	Views[item.replace('./', '').split('.')[0]] = {}
	Views[item.replace('./', '').split('.')[0]].comp = comps(item)[item.replace('./', '').split('.')[0]]
	Views[item.replace('./', '').split('.')[0]].icon = comps(item).icon
})

var img = {}
var imgs = require.context('./img', false, /.*/)
imgs.keys().forEach((item) => {
	img[item.replace('./', '').split('.')[0]] = imgs(item)
})

class App extends Component {
	static propTypes = { cookies: instanceOf(Cookies).isRequired }
	constructor(props) {
		super(props);



		this.state = {
			loggedIn: false,
			user: '',
			domain: '',
			org: '',
			progress: false,
			dynamicParams: {},
			RealTimeStats: {},
			firstName: '',
			lastName: '',
			adjustingPIN: false,
			adjustPIN: '',
			adjustPINError: '',
			availableViews: [],
			views: [],
			memo: false,
			loginError: '',
			activeView: "RealTimeStats"
		};
	}


	adjustPIN = (e) => {
		this.setState({ adjustingPIN: true, adjustPIN: '', adjustPINError: '' })
	}
	adjustPINChange = (e) => {
		this.setState({ adjustPIN: e.target.value, adjustPINError: '' });
	}
	confirmAdjustPIN = () => {
		if (this.state.adjustPIN.length < 1) { this.setState({ adjustPINError: 'Please Enter a New Password' }) };
		this.setState({ loading: true });
		this.ws.send(JSON.stringify({ route: 'adjustPIN', user: this.state.user, adjustPIN: this.state.adjustPIN }))
	}
	checkEnter = (e) => {
		if (e.keyCode === 13) {
			this.confirmAdjustPIN();
		}
	}
	base64ToBlob = (base64Data, contentType) => {

		contentType = contentType || '';
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}

	revertToDashboard(e) {
		window.location.hash = ''
		e.stopPropagation();
	}

	componentWillMount() {
		this.cookies = this.props.cookies;

		if (this.cookies.get('dme') == 'true' && window.location.pathname == '/loginwithmicrosoft') {
			this.cookies.remove('dme')
			console.log('hit 4')
			window.location.pathname = '/dme'
		} else {
			console.log('hit 1')
			if (window.location.pathname == '/dme') {
				console.log('hit 2')
				this.cookies.set('dme', true, { path: '/' })
			}
			console.log('hit 3')
			this.connectWebSocket()


			this.saveCreds = (loginCreds) => {
				//this.setState({ loginCreds: loginCreds })
				//this.cookies.set('loginCreds', loginCreds, { path: '/' })
			}
			if (this.cookies.get('loggedIn') === 'true') {
				this.setState({
					//loggedIn: this.cookies.get('loggedIn') === 'true' ? true : false,
					//loginCreds: this.cookies.get('loginCreds'),
					activeView: '',
				});
			}


			this.pingTimer = 30000
			this.ping = setTimeout(this.checkSocket, this.pingTimer)


		}


	}

	connectWebSocket = () => {
		if (this.ws) {
			this.ws.close()
			delete this.ws
		}
		var protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
		var port = window.location.hostname == 'localhost' ? ':8765' : window.location.port ? ':' + window.location.port : ''

		this.forceUpdate()

		this.ws = new WebSocket(protocol + '//' + window.location.hostname + port);

		this.ws.onopen = () => {
			if (this.cookies.get('microsoftNonce')) {
				this.ws.send(JSON.stringify({ route: 'completemicrosoftlogin', nonce: this.cookies.get('microsoftNonce') }))
			} else if (this.state.loggedIn) {
				this.ws.send(JSON.stringify({ route: 'login', reconnect: true, session: this.state.session }))
			}
		};

		this.ws.onmessage = (e) => {
			var data = JSON.parse(e.data);

			if (data.route === "setState") {
				if (data.state.hasOwnProperty('domain')) {
					window.domain = data.state.domain
				}
				if (data.state.loggedIn && this.cookies.get('impersonating') && this.state.domain != this.cookies.get('impersonating')) {
					data.state.domain = this.cookies.get('impersonating')
					console.log('impersonating')
					console.log("Setting Application State")
					console.log(data.state)
					this.setState(data.state, () => {
						this.ws.send(JSON.stringify({ route: 'impersonate', domain: this.cookies.get('impersonating') }))
					})


				} else if (data.state.hasOwnProperty('RealTimeStats')) {
					if (this.state.activeView == 'Realtime%20Statistics') {
						console.log("Setting Application State")
						console.log(data.state)
						this.setState(data.state)
					}

				} else if (Object.keys(data.state).length == 1 && data.state.hasOwnProperty('NotificationDashboard')) {
					if (this.state.activeView == 'Notification%20Dashboard') {
						console.log("Setting Application State")
						console.log(data.state)
						this.setState(data.state)
					}

				} else {
					console.log("Setting Application State")
					console.log(data.state)
					this.setState(data.state)
					//this.setState({adjustingPIN: false, loading: false})
					for (var stateType in data.state) {
						if (stateType === 'loggedIn') {
							this.cookies.set(stateType, data.state[stateType], { path: '/' })
						} else if (stateType === 'impersonating' && data.state[stateType]) {
							this.cookies.set(stateType, this.state.domain, { path: '/' })
						}
					}
				}
			} else if (data.route === "alterState") {
				console.log("Altering Application State")
				console.log(data.value)
				console.log(data)

				var altState = {}

				if (this.state[data.state]) {
					altState[data.state] = this.state[data.state]
				} else {
					altState[data.state] = {}
				}
				//if path is an array, then we need to loop through the array and set the value at the end of the path
				if (Array.isArray(data.path)) {
					var path = altState[data.state]
					for (var i = 0; i < data.path.length; i++) {
						if (i === data.path.length - 1) {
							path[data.path[i]] = data.value
						} else {
							if (path[data.path[i]]) {
								path = path[data.path[i]]
							} else {

								path[data.path[i]] = {}
								path = path[data.path[i]]
							}
						}
					}
				} else {
					altState[data.state][data.path] = data.value
				}

				this.setState(altState)
			} else if (data.route === "deleteState") {
				console.log("Deleting Application State")
				console.log(data.path)

				var delState = {}
				delState[data.state] = this.state[data.state]
				//if path is an array, then we need to loop through the array and set the value at the end of the path
				if (Array.isArray(data.path)) {
					var path = delState[data.state]
					for (var i = 0; i < data.path.length; i++) {
						if (i === data.path.length - 1) {
							delete path[data.path[i]]
						} else {
							if (path[data.path[i]]) {
								path = path[data.path[i]]
							} else {
								path[data.path[i]] = {}
								path = path[data.path[i]]
							}
						}
					}
				} else {
					delete delState[data.state][data.path]

				}



				this.setState(delState)
			} else if (data.route === "memo") {
				console.log("Alerting with memo")
				console.log(data.content)

				this.setState({ memo: data })
			} else if (data.route === "progress") {
				console.log("Updating Progress")
				console.log(data.content)

				this.setState({ progress: data })
			} else if (data.route === "loginWithMicrosoft") {
				console.log("Logging in with Microsoft")
				console.log(data.nonce)
				this.cookies.set('microsoftNonce', data.nonce, { path: '/' })
				window.location = "https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=0d803506-1f33-43b9-9149-ac49d3ace923&response_type=id_token&redirect_uri=" + window.location.origin + "/loginwithmicrosoft&response_mode=form_post&scope=openid&state=12345&nonce=" + data.nonce

			} else if (data.route === "download") {
				console.log("Updating Progress")
				console.log(data.file)

				if (window.navigator.msSaveOrOpenBlob) {
					console.log('This is IE!')
					var fileData = this.base64ToBlob(data.file, "application/zip");
					var blobObject = new Blob([fileData]);

					window.navigator.msSaveOrOpenBlob(blobObject, data.filename);

				} else {
					var url = window.URL.createObjectURL(this.base64ToBlob(data.file, "application/zip"));
					var a = document.createElement("a");
					a.style = "display: none";
					a.href = url;
					a.download = data.filename;

					document.body.appendChild(a);
					a.click();
					document.body.removeChild(a);
				}
			}
		};
	}

	checkSocket = () => {
		this.ping = setTimeout(this.checkSocket, this.pingTimer)

		if (this.ws.readyState !== 1) {
			this.forceUpdate();
			console.log(this.ws.readyState)
			this.pingTimer = Math.round(this.pingTimer * 1.25)
			this.connectWebSocket()
		} else {
			this.pingTimer = 1000
		}
	}

	logout = () => {
		this.cookies.remove('microsoftNonce', { path: '/' })
		this.ws.send(JSON.stringify({ route: 'logOut' }))
	}

	cancel = () => {
		this.setState({ memo: false, adjustingPIN: false, adjustPIN: '', adjustPINError: '', progress: false })
	}

	revert = (e) => {
		this.cookies.remove('impersonating', { path: '/' })
		this.ws.send(JSON.stringify({ route: 'revert' }))
	}

	activateView = () => {
		if (window.location.hash.length > 3) {
			this.setState({ activeView: window.location.hash.replace('#', '') })
		} else if (this.state.availableViews.length > 0) {
			window.location.hash = this.state.availableViews[0].title
			this.activateView()
		}
	}

	componentDidMount() {
		window.addEventListener("hashchange", this.activateView, false);
	}

	componentDidUpdate() {
		if (window.location.hash.length < 3 && this.state.views.length > 0) {
			this.activateView()
		}
		if (this.state.loggedIn && !this.state.activeView) {
			this.activateView()
		}
	}
	activate = view => e => {
		window.location.hash = view;
		e.stopPropagation();
	}

	render() {
		var adjustPIN = ""
		if (this.state.adjustingPIN || this.state.passwordExpired) {
			adjustPIN = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter}>
						{this.state.passwordExpired ? '' : <div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>}

						<div className="snazzyInputBox">
							<input className="textInput" type="text" required value={this.state.adjustPIN} onChange={this.adjustPINChange} ></input>
							<span className="inputBar"></span><label className="textLabel">Choose Your New Password</label>
						</div>
						<div className="error">{this.state.adjustPINError}</div>
						{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmAdjustPIN}>Change My Password</div>}
					</div>
				</div>
			)
		}
		var memo = ""
		if (this.state.memo) {
			memo = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>

						<div style={{ color: this.state.memo.color, marginBottom: '25px' }} >
							{this.state.memo.content}
						</div>

						{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.cancel}>Okay</div>}
					</div>
				</div>
			)
		}
		var impersonateButton = ""
		if (this.state.impersonating) {
			impersonateButton = <div style={{
				position: 'absolute',
				top: '10px',
				right: '10px',
				padding: '8px 12px',
				backgroundColor: this.state.color, // Dark blueish-gray background color
				color: '#EFEFEF', // Light gray text color
				borderRadius: '8px', // Rounded corners
				boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.1)', // Soft shadow
				fontWeight: '500', // Medium-bold text
				fontSize: '14px', // Text size
				letterSpacing: '0.5px' // Slight spacing between characters for better legibility
			}}>
				Administrating {this.state.org}
			</div>
		}


		var progress = ""
		if (this.state.progress) {
			progress = (
				<div className="blackout">
					<div className="pop" onKeyUp={this.checkEnter} style={{ width: '300px' }}>
						<div className="viewCloser" style={{ display: 'block' }} onClick={this.cancel}></div>
						<pre ><div style={{ fontFamily: 'Arial' }}>{this.state.progress.content}</div></pre>
						<div style={{ height: '20px', transition: 'width .5s', backgroundColor: this.state.progress.color, width: this.state.progress.perc + '%', margin: '25px 0px' }} ></div>
					</div>
				</div>
			)
		}
		if (window.location.pathname == '/enroll') {
			//return (<Enrollment />);
		} else if (this.state.TwoFactor) {
			//loggedIn: false, loading: false, TwoFactor: true, user: user
			return (<TwoFactor ws={this.ws} loggedIn={this.state.loggedIn} session={this.state.session} loginError={this.state.loginError} />);
		} else if (!this.state.loggedIn) {
			return (<Login saveCreds={this.saveCreds} ws={this.ws} onLoginAttempt={this.loginAttempt} onLogin={this.successfulLogin} loggedIn={this.state.loggedIn} loginError={this.state.loginError} />);
		} else if (window.location.pathname == '/dme') {
			//return (<Dme />);
		} else {
			if (this.state.views && this.state.views.length > 0 && encodeURIComponent(this.state.activeView) !== encodeURIComponent(window.location.hash.replace('#', ''))) {
				console.log(this.state.activeView + decodeURIComponent(window.location.hash.replace('#', '')) + this.state.views[0].title)
				window.location.hash = encodeURIComponent(this.state.views[0].title)
			}

			for (var views = [], i = 0; i < this.state.views.length; i++) {
				for (var viewData = {}, a = 0; a < this.state.views[i].data.length; a++) {
					viewData[this.state.views[i].data[a]] = this.state[this.state.views[i].data[a]];
				}
				viewData[this.state.views[i].view] = this.state[this.state.views[i].view]

				var ViewType = Views[this.state.views[i].view].comp
				window[this.state.views[i].view + 'Functions'] = ViewType
				views.push(
					<div key={"view" + i} id={this.state.views[i].view} className={this.state.activeView === encodeURIComponent(this.state.views[i].title) ? 'active view' : 'view'} >
						<div className="viewHeader">
							<h1>{this.state.views[i].title}</h1>
						</div>
						<ViewType img={img} view={this.state.views[i].view} ref={(component) => { if (component) { window[component.props.view + 'Functions'] = component } }} features={this.state.features} ws={this.ws} data={viewData} active={this.state.activeView === encodeURIComponent(this.state.views[i].title)} />
					</div>
				)
			}
			var navOptions = []
			for (var option of this.state.availableViews) {
				navOptions.push(<div key={option.title} style={this.state.activeView && (this.state.activeView == encodeURIComponent(option.title) || this.state.activeView == option.title) ? { backgroundColor: '#2A6AA9' } : null} className="menuOption" onClick={this.activate(option.title)}><img src={img[Views[option.view].icon]} alt={option.title + " Icon"} /><div>{option.title}</div></div>)
			}
			return (
				<div style={{ display: "flex" }}>
					<nav className={this.state.menu ? 'active' : ''} style={{ overflowY: 'auto', overflowX: 'hidden' }}>
						<div style={{ position: 'absolute', width: '300px' }}>
							{navOptions}
						</div>
					</nav>


					<div className="App">
						<div className="header">
							<img src={img.dirad_logo} className="App-logo" alt="logo" onClick={this.revertToDashboard} />
						</div>
						{impersonateButton}


						<div className="body">
							<div className="viewer activated">
								{views}
							</div>
						</div>

						<div className="footer">
							<span>
								<img src={this.ws && this.ws.readyState === 1 ? img.tinyConnected : img.tinyDisconnected} alt="Connection Icon" />
								<span style={{ lineHeight: '28px' }}>{this.ws && this.ws.readyState === 1 ? "Connected" : "Reconnecting"}</span>
							</span>

							<span>
								<img style={{ margin: '0px 5px' }} src={img.tinyBuilding} alt="Domain Icon" />
								<span style={{ lineHeight: '28px' }}>
									{this.state.org}
									{this.state.impersonating ? <span style={{ cursor: "pointer" }} onClick={this.revert}> (Revert)</span>
										: ""}

								</span>
							</span>

							<span>
								<img src={img.tinyUser} alt="User Icon" />
								<span style={{ lineHeight: '28px' }}>{this.state.user.email + " (" + this.state.user.firstName + ' ' + this.state.user.lastName + ")"}</span>
							</span>

							<span style={{ cursor: 'pointer' }} onClick={this.adjustPIN}>
								<img src={img.tinyLock} alt="Lock Icon" />
								<span style={{ lineHeight: '28px' }}>Change My Password</span>
							</span>

							<span style={{ cursor: 'pointer' }} onClick={this.logout}>
								<img src={img.tinyLogout} alt="Logout Icon" />
								<span style={{ lineHeight: '28px' }}>Logout</span>
							</span>
						</div>

						{adjustPIN}
						{memo}
						{progress}

					</div>
				</div>
			);
		}
	}
}
export default withCookies(App);
